import { render, staticRenderFns } from "./DisplayNationalityPerStaffMemberItem.vue?vue&type=template&id=cff964bc"
import script from "./DisplayNationalityPerStaffMemberItem.vue?vue&type=script&lang=js"
export * from "./DisplayNationalityPerStaffMemberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports